export default "__VITE_ASSET__E2ujxAjI__"